import React, { useState } from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Autocomplete, Tooltip, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus, getGlobalCookie } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { addClauseApi, updateClauseApi } from '../apiServices';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const assetTypeOptions = ["Airframe", "Engine", "APU", "LG", "Propeller"];
const restrictedLessorIds = [483, 484];

const ClauseCRU = ({ clauseCRU, modeType, getResponseBack, onToggleModal, params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [clause, setClause] = useState(clauseCRU?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess') || "null");
    const assetTypeDropdownOptions = restrictedLessorIds.includes(lessorAccess?.id) ? ["Engine"] : assetTypeOptions;

    const onFieldChange = (keyParam, value) => {
        setClause({ ...clause, [keyParam]: value });

    }
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onAddEditPartiesclause = () => {
        let validationInputs = {};
        validationInputs = {
            name: clause?.name?.trim() ? "" : "Please enter Name",
            asset_type: clause?.asset_type ? "" : "Please select Asset Type",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (clause?.id) {
                globalPutService(updateClauseApi({ asset_slug: clause?.slug }), clause)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Clause`, success_msg: response?.data?.message, item_id: clause?.id, payload: clause, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Clause`, error_msg: response?.data?.message, item_id: clause?.id, payload: clause, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addClauseApi(), clause).then((response) => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Clause`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: clause, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Clause`, error_msg: response?.data?.message, item_id: null, payload: clause, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Clause`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Clause`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                // onClose={(event, reason) => { if (reason !== 'backdropClick') { onToggleModal(); } }}
                aria-labelledby="customized-dialog-title"
                className="setting-clause-dialog"
                maxWidth="md"
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add Clause" : modeType === "edit" ? "Edit Clause" : "View Clause"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Tooltip title={clause?.name?.length > 23 ? clause?.name : ""} placement="bottom" arrow >
                                <TextField
                                    required
                                    id="name"
                                    label="Name"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    margin="normal"
                                    error={error?.name || false}
                                    helperText={error?.name || ''}
                                    disabled={modeType === "view"}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    value={clause?.name || ""}
                                    onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value?.length <= 100 ? onFieldChange("name", e.target.value.trimStart()) : null : e.preventDefault()}
                                    onFocus={() => onRestErrorKey("name")}
                                />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={assetTypeDropdownOptions}
                                getOptionLabel={(option) => option || ""}
                                disabled={modeType === 'view'}
                                value={clause?.asset_type || null}
                                onFocus={() => onRestErrorKey("asset_type")}
                                onChange={(e, value) => onFieldChange("asset_type", value)}
                                slotProps={{
                                    listbox: { style: { maxHeight: 140 } }
                                }}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                    <TextField
                                        {...params}
                                        label="Asset Type"
                                        margin='normal'
                                        size='small'
                                        required
                                        error={!!error.asset_type}
                                        helperText={error.asset_type}
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        disabled={modeType === 'view'}
                                    />
                                </Tooltip>)}}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={clause?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    rows={3}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    value={clause?.remarks || ""}
                                    fullWidth
                                    multiline
                                    disabled={modeType === "view"}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                />
                            </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> {modeType === "view" ? "Close" : "Cancel"} </Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditPartiesclause(); }} >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>}

                </DialogActions>
            </Dialog>
        </>
    )
}

export default ClauseCRU